export default {
    modules: {
        input: ["text", "text_i18n", "number", "date", "image", "email", "password", "file"],
        image: ["carousel"],
        text: ["default", "editor"],
        select: ["text", "number", "image", "relation","external"],
        radio: ["text", "number"],
        checkbox: ["text", "number", "bool"],
        table: ["default", "custom"],
        picker: ["date", "daterange", "datetime", "time"],
        fieldset: ["default"],
        data: ["json"],
        //reference: ["text"]
    },
    constraints: {
        string: {
            required: false,
            placeholder: "",
            length: {
                min: null,
                max: null
            }
        },

        number: {
            required: false,
            placeholder: "",
            min: null,
            max: null
        }
    },

    defaultValueResolver: {
        
    }
   
}

// idlTypeMap maps every field module:type combination to the IDL primitive type
// it produces at runtime. Used by idlFieldWarnings in Settings.vue to warn
// component authors when the IDL declaration doesn't match the widget's actual
// output type, so writes won't be silently rejected at runtime.
//
// ⚠️  MAINTENANCE: whenever a new module:type combination is added to the
//    `modules` map above, a corresponding entry MUST be added here.
//    If the widget can return different primitive types depending on its
//    configuration (e.g. single vs multi-select), choose the most common
//    runtime value and document any exceptions inline.
//    Use 'any' only when the output type is genuinely dynamic (e.g. data:json).
export const idlTypeMap = {
    'input:text':       'string',
    'input:text_i18n':  'object',
    'input:number':     'number',
    'input:date':       'string',
    'input:image':      'string',
    'input:email':      'string',
    'input:password':   'string',
    'input:file':       'string',
    'image:carousel':   'array',
    'text:default':     'string',
    'text:editor':      'string',
    'select:text':      'string',
    'select:number':    'number',
    'select:image':     'string',
    'select:relation':  'string',
    'select:external':  'any',
    'radio:text':       'string',
    'radio:number':     'number',
    'checkbox:text':    'array',
    'checkbox:number':  'array',
    'checkbox:bool':    'boolean',
    'table:default':    'array',
    'table:custom':     'array',
    'picker:date':      'string',
    'picker:daterange': 'object',
    'picker:datetime':  'string',
    'picker:time':      'string',
    'fieldset:default': 'object',
    'data:json':        'any',
}